import { c as _c } from "react/compiler-runtime";
/* eslint-disable @next/next/no-img-element */
import { cva } from 'class-variance-authority';
import type { LoadingSpinnerProps } from '../loading-spinner';
import LoadingSpinner from '../loading-spinner';
import type { AvatarSize } from './avatar.types';
export type AvatarProps = {
  loading?: boolean;
  name: string;
  size?: AvatarSize;
  src?: string | null;
};
const Avatar = t0 => {
  const $ = _c(12);
  const {
    loading: t1,
    name,
    size: t2,
    src
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  if (loading) {
    const t3 = src ? "secondary" : "primary";
    let t4;
    if ($[0] !== size || $[1] !== t3) {
      t4 = fallback({
        size,
        variant: t3
      });
      $[0] = size;
      $[1] = t3;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    const t5 = loadingIndicatorSize[size];
    let t6;
    if ($[3] !== t5) {
      t6 = <LoadingSpinner size={t5} color="translucid" />;
      $[3] = t5;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    let t7;
    if ($[5] !== t4 || $[6] !== t6) {
      t7 = <div className={t4}>{t6}</div>;
      $[5] = t4;
      $[6] = t6;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    return t7;
  }
  let t3;
  if ($[8] !== name || $[9] !== size || $[10] !== src) {
    t3 = src ? <div className={imageContainer({
      size
    })}><img src={src} alt={name} className="h-full w-full object-cover" /></div> : <div role="img" aria-label={name} className={fallback({
      size
    })}>{name.charAt(0)}</div>;
    $[8] = name;
    $[9] = size;
    $[10] = src;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export const loadingIndicatorSize: Record<AvatarSize, LoadingSpinnerProps['size']> = {
  compact: 'compact',
  default: 'default',
  large: 'default',
  xlarge: 'large'
};
const imageContainer = cva(['flex', 'items-center', 'justify-center', 'overflow-hidden', 'rounded-full', 'border', 'border-solid', 'border-tertiary', 'bg-primary'], {
  variants: {
    size: {
      compact: 'size-6',
      default: 'size-8',
      large: 'size-10',
      xlarge: 'size-[72px]'
    }
  },
  defaultVariants: {
    size: 'default'
  }
});
const fallback = cva(['flex', 'items-center', 'justify-center', 'rounded-full', 'uppercase', 'select-none', 'bg-quaternary', 'text-primary'], {
  variants: {
    size: {
      compact: 'size-6 text-label-2',
      default: 'size-8 text-label-2',
      large: 'size-10 text-label-1',
      xlarge: 'size-[72px] text-display-3'
    },
    variant: {
      primary: '',
      secondary: 'bg-primary border border-solid border-tertiary'
    }
  },
  defaultVariants: {
    size: 'default',
    variant: 'primary'
  }
});
export default Avatar;